/* =============================================================
   HERA B — Custom theme interactions
   ============================================================= */

function initAllHeraCustomizations() {
  initProductInfoLayout();
  initAccordionIndicators();
  initAccordionDrawer();
  initPairsWellWith();
  initFooterAccordions();
}

document.addEventListener('DOMContentLoaded', initAllHeraCustomizations);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initAllHeraCustomizations);
}

// ============================================================
// 5. FOOTER ACCORDIONS
// ============================================================
function initFooterAccordions() {
  const accordions = document.querySelectorAll('.footer-accordion');
  if (!accordions.length) return;

  function updateFooterAccordions() {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    accordions.forEach(acc => {
      if (isDesktop) {
        acc.setAttribute('open', '');
      } else if (!acc.dataset.userToggled) {
        acc.removeAttribute('open');
      }
    });
  }

  accordions.forEach(acc => {
    if (acc.dataset.heraBound) return;
    acc.dataset.heraBound = '1';
    acc.addEventListener('toggle', () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (!isDesktop) acc.dataset.userToggled = 'true';
    });
  });

  if (!window.heraFooterBound) {
    window.addEventListener('resize', updateFooterAccordions);
    window.heraFooterBound = true;
  }
  updateFooterAccordions();
}


// ============================================================
// 1. PRODUCT INFO LAYOUT (desktop)
// ============================================================
function initProductInfoLayout() {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  const infoContainer = document.querySelector('.product__info-container');
  const infoWrapper   = document.querySelector('.product__info-wrapper');
  const mediaWrapper  = document.querySelector('.product__media-wrapper');
  if (!infoContainer || !infoWrapper || !mediaWrapper) return;

  if (infoContainer.classList.contains('hera-layout-init')) return;

  infoContainer.classList.remove('product__column-sticky');
  infoContainer.style.position = 'static';
  infoContainer.classList.add('hera-layout-init');

  function syncHeight() {
    infoWrapper.style.minHeight = mediaWrapper.offsetHeight + 'px';
  }
  syncHeight();
  new ResizeObserver(syncHeight).observe(mediaWrapper);

  const buyBtn = infoContainer.querySelector('button[name="add"]');
  if (!buyBtn) return;
  let buyBlock = buyBtn;
  while (buyBlock.parentElement && buyBlock.parentElement !== infoContainer) {
    buyBlock = buyBlock.parentElement;
  }

  const descEl = infoContainer.querySelector('.product__description');
  let descBlock = null;
  if (descEl) {
    descBlock = descEl;
    while (descBlock.parentElement && descBlock.parentElement !== infoContainer) {
      descBlock = descBlock.parentElement;
    }
  }

  const children = Array.from(infoContainer.children);
  const buyIdx   = children.indexOf(buyBlock);
  if (buyIdx === -1) return;

  const assignedTop  = [];
  const assignedDesc = [];
  const assignedBot  = [];

  children.forEach((child, idx) => {
    if (child === descBlock) {
      assignedDesc.push(child);
    } else if (idx <= buyIdx) {
      assignedTop.push(child);
    } else {
      assignedBot.push(child);
    }
  });

  const stickyTop = document.createElement('div');
  stickyTop.className = 'hera-sticky-top';
  infoContainer.appendChild(stickyTop);
  assignedTop.forEach(el => stickyTop.appendChild(el));

  if (assignedDesc.length) {
    const scrollDesc = document.createElement('div');
    scrollDesc.className = 'hera-scroll-desc';
    infoContainer.appendChild(scrollDesc);
    assignedDesc.forEach(el => scrollDesc.appendChild(el));
  }

  const stickyBot = document.createElement('div');
  stickyBot.className = 'hera-sticky-bot';
  infoContainer.appendChild(stickyBot);
  assignedBot.forEach(el => stickyBot.appendChild(el));

  function positionSticky() {
    const headerEl = document.querySelector('.header-wrapper, .shopify-section-header-sticky, header');
    const headerH  = headerEl ? headerEl.getBoundingClientRect().height : 0;
    stickyTop.style.top = headerH + 'px';
    requestAnimationFrame(() => {
      const topH = stickyTop.getBoundingClientRect().height;
      stickyBot.style.top = (headerH + topH) + 'px';
    });
  }

  positionSticky();
  new ResizeObserver(positionSticky).observe(stickyTop);
  const hdr = document.querySelector('.header-wrapper, header');
  if (hdr) new ResizeObserver(positionSticky).observe(hdr);
}


// ============================================================
// 2. ACCORDION +/− INDICATORS
// ============================================================
function initAccordionIndicators() {
  function addIndicator(details) {
    if (details.dataset.heraIndicator) return;
    details.dataset.heraIndicator = '1';
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    summary.querySelectorAll('svg, .svg-wrapper').forEach(el => el.style.display = 'none');
    const indicator = document.createElement('span');
    indicator.className = 'hera-accordion-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.textContent = '+';
    summary.prepend(indicator);
    details.addEventListener('toggle', () => {
      indicator.textContent = details.open ? '−' : '+';
    });
  }

  function setup() {
    document.querySelectorAll('.product__accordion details').forEach(addIndicator);
    document.querySelectorAll('.hera-drawer-item').forEach(addIndicator);
  }

  setup();
  document.addEventListener('shopify:section:load', setup);
  new MutationObserver(setup).observe(document.body, { childList: true, subtree: true });
}


// ============================================================
// 3. ACCORDION DRAWER (desktop only)
// ============================================================
function initAccordionDrawer() {
  let drawer = document.getElementById('hera-accordion-drawer');
  if (!drawer) {
    drawer = document.createElement('div');
    drawer.id = 'hera-accordion-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = `
      <div class="hera-drawer-overlay"></div>
      <div class="hera-drawer-panel" role="dialog" aria-modal="true">
        <button class="hera-drawer-close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <line x1="1" y1="1" x2="13" y2="13" stroke="currentColor" stroke-width="1.2"/>
            <line x1="13" y1="1" x2="1" y2="13" stroke="currentColor" stroke-width="1.2"/>
          </svg>
        </button>
        <div class="hera-drawer-body"></div>
      </div>
    `;
    document.body.appendChild(drawer);
  }

  const overlay  = drawer.querySelector('.hera-drawer-overlay');
  const closeBtn = drawer.querySelector('.hera-drawer-close');
  const body     = drawer.querySelector('.hera-drawer-body');

  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function openDrawer(clickedDetails) {
    const allAccordions = document.querySelectorAll('.product__accordion details');
    body.innerHTML = Array.from(allAccordions).map(details => {
      const title   = details.querySelector('.accordion__title')?.textContent.trim() || '';
      const content = details.querySelector('.accordion__content')?.innerHTML || '';
      const isOpen  = details === clickedDetails;
      return `<details class="hera-drawer-item"${isOpen ? ' open' : ''}>
        <summary><span>${title}</span></summary>
        <div class="hera-drawer-item__body rte">${content}</div>
      </details>`;
    }).join('');

    body.querySelectorAll('.hera-drawer-item').forEach(d => {
      if (d.dataset.heraIndicator) return;
      d.dataset.heraIndicator = '1';
      const indicator = document.createElement('span');
      indicator.className = 'hera-accordion-indicator';
      indicator.setAttribute('aria-hidden', 'true');
      indicator.textContent = d.open ? '−' : '+';
      d.querySelector('summary').prepend(indicator);
      d.addEventListener('toggle', () => { indicator.textContent = d.open ? '−' : '+'; });
    });

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hera-drawer-open');
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hera-drawer-open');
    document.querySelectorAll('.product__accordion details[open]').forEach(d => d.removeAttribute('open'));
  }

  if (!drawer.dataset.heraBound) {
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    drawer.dataset.heraBound = '1';
  }

  function attachListeners() {
    document.querySelectorAll('.product__accordion details').forEach(details => {
      if (details.dataset.heraBound) return;
      details.dataset.heraBound = '1';
      details.querySelector('summary').addEventListener('click', e => {
        if (!isDesktop()) return;
        e.preventDefault();
        e.stopPropagation();
        openDrawer(details);
      });
    });
  }
  attachListeners();
  document.addEventListener('shopify:section:load', attachListeners);
}


// ============================================================
// 4. PAIRS WELL WITH
// Desktop: compact thumbnail row with hover name/price
// Mobile:  large swipeable portrait cards with name/price
// ============================================================
function initPairsWellWith() {
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;

  function extractPrice(scope) {
    const selectors = ['.hera-default-price', '.price-item--regular', '.price-item--sale', '.price-item', '.price .money', '.money'];
    for (const sel of selectors) {
      const el = scope.querySelector(sel);
      if (!el) continue;
      const txt = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) return txt;
    }
    return '';
  }

  function extractTitle(scope) {
    return (
      scope.querySelector('.card__heading a')?.innerText ||
      scope.querySelector('.card__heading')?.innerText ||
      scope.querySelector('h3 a')?.innerText ||
      scope.querySelector('h3')?.innerText || ''
    ).trim();
  }

  function extractImg(scope) {
    return scope.querySelector('img');
  }

  function extractLink(scope) {
    return scope.querySelector('a[href]');
  }

  // ---- DESKTOP ----
  function buildDesktop(container) {
    if (container.querySelector('.hera-pairs-wrap')) return;
    const items = container.querySelectorAll('.complementary-slide li, .slider__slide li, aside li, .list-unstyled li');
    if (!items.length) return;

    container.classList.add('hera-pairs-built');

    const inner = container.querySelector('.complementary-products__container') || container.querySelector('aside') || container;
    const blockLabel = inner.querySelector('.summary__title .accordion__title, .summary__title h2')?.innerText?.trim() || 'Pairs well with';

    const row = document.createElement('ul');
    row.className = 'hera-pairs-row';
    const itemData = [];

    items.forEach(li => {
      const imgEl  = extractImg(li);
      const linkEl = extractLink(li);
      if (!imgEl) return;
      itemData.push({ titleTxt: extractTitle(li), priceTxt: extractPrice(li) });
      const newLi = document.createElement('li');
      const link  = document.createElement('a');
      link.href   = linkEl?.href || '#';
      const img   = document.createElement('img');
      img.src     = imgEl.src; img.srcset = imgEl.srcset || ''; img.sizes = '25vw';
      img.alt     = imgEl.alt || ''; img.loading = 'lazy';
      link.appendChild(img); newLi.appendChild(link); row.appendChild(newLi);
    });

    if (!itemData.length) return;

    const header = document.createElement('div');
    header.className = 'hera-pairs-header';
    header.innerHTML = `<span class="hera-pairs-header__label">${blockLabel}</span><span class="hera-pairs-header__name"></span><span class="hera-pairs-header__price"></span>`;

    const labelEl = header.querySelector('.hera-pairs-header__label');
    const nameEl  = header.querySelector('.hera-pairs-header__name');
    const priceEl = header.querySelector('.hera-pairs-header__price');

    Array.from(row.children).forEach((newLi, idx) => {
      const { titleTxt, priceTxt } = itemData[idx];
      newLi.addEventListener('mouseenter', () => { labelEl.style.display='none'; nameEl.style.display='block'; nameEl.textContent=titleTxt; priceEl.textContent=priceTxt; });
      newLi.addEventListener('mouseleave', () => { labelEl.style.display=''; nameEl.style.display='none'; nameEl.textContent=''; priceEl.textContent=''; });
    });

    const wrap = document.createElement('div');
    wrap.className = 'hera-pairs-wrap';
    wrap.appendChild(header); wrap.appendChild(row);
    inner.prepend(wrap);
  }

  // ---- MOBILE ----
  function buildMobile(container) {
    if (container.querySelector('.hera-mobile-pairs-track')) return;
    // Collect all li items from all slides
    const items = Array.from(container.querySelectorAll('.complementary-slide li, .list-unstyled li'));
    if (!items.length) return;

    container.classList.add('hera-pairs-built-mobile');

    const inner = container.querySelector('.complementary-products__container') || container.querySelector('aside') || container;

    // Get heading text
    const headingEl = inner.querySelector('.summary__title .accordion__title, .summary__title h2');
    const headingTxt = headingEl?.innerText?.trim() || 'Pairs well with';

    // Build heading
    const heading = document.createElement('div');
    heading.className = 'hera-mobile-pairs-heading';
    heading.textContent = headingTxt;

    // Build scroll track
    const track = document.createElement('div');
    track.className = 'hera-mobile-pairs-track';

    items.forEach(li => {
      const imgEl  = extractImg(li);
      const linkEl = extractLink(li);
      if (!imgEl) return;

      const titleTxt = extractTitle(li);
      const priceTxt = extractPrice(li);
      const href     = linkEl?.href || '#';

      const card = document.createElement('a');
      card.href = href;
      card.className = 'hera-mobile-pairs-card';

      const imgWrap = document.createElement('div');
      imgWrap.className = 'hera-mobile-pairs-img';
      const img = document.createElement('img');
      img.src = imgEl.src; img.srcset = imgEl.srcset || ''; img.sizes = '65vw';
      img.alt = imgEl.alt || titleTxt; img.loading = 'lazy';
      imgWrap.appendChild(img);

      const info = document.createElement('div');
      info.className = 'hera-mobile-pairs-info';
      if (titleTxt) {
        const name = document.createElement('div');
        name.className = 'hera-mobile-pairs-name';
        name.textContent = titleTxt;
        info.appendChild(name);
      }
      if (priceTxt) {
        const price = document.createElement('div');
        price.className = 'hera-mobile-pairs-price';
        price.textContent = priceTxt;
        info.appendChild(price);
      }

      card.appendChild(imgWrap);
      card.appendChild(info);
      track.appendChild(card);
    });

    // Replace slideshow content with our clean structure
    const slideshow = inner.querySelector('slideshow-component') || inner.querySelector('.complementary-slider');
    if (slideshow) slideshow.style.display = 'none';
    const summaryTitle = inner.querySelector('.summary__title');
    if (summaryTitle) summaryTitle.style.display = 'none';

    inner.appendChild(heading);
    inner.appendChild(track);
  }

  function buildAll() {
    document.querySelectorAll('.complementary-products').forEach(c => {
      if (isDesktop) buildDesktop(c); else buildMobile(c);
    });
  }

  buildAll();
  new MutationObserver(buildAll).observe(document.body, { childList: true, subtree: true });
}
